import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/posts"

export const List = async (values) => {
    return await axiosInstance(options).post(`${path}/list`, values);
};

export const Details = async (id) => {
  return await axiosInstance(options).get(`${path}/details/${id}`);
};

export const Delete = async (id) => {
  return await axiosInstance(options).post(`${path}/delete/${id}`);
};
